var AppModeService = /** @class */ (function () {
    function AppModeService() {
    }
    Object.defineProperty(AppModeService, "isDevelopmentMode", {
        get: function () {
            return location.port === '4200';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModeService, "isStaging", {
        get: function () {
            return location.href.includes('staging');
        },
        enumerable: true,
        configurable: true
    });
    return AppModeService;
}());
export { AppModeService };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/services/app.mode.service.ts.pre-build-optimizer.js